import { setGlobalCSSVariables } from 'helpers/styleHelpers';
import { useRouter } from 'next/router';
import { pathnames } from 'utils/routerHelpers';

import React, { useEffect } from 'react';

import { classNames } from '@thinkific/chalk/utils';

import { useCommunityContext } from 'components/CommunityContext';
import { useSiteFeaturesContext } from 'components/SiteFeaturesContext';
import { useChatContext } from 'components/new/chat/providers/ChatProvider/ChatProvider';
import { Sidebar, SidebarType } from 'components/new/layout/Sidebar/Sidebar';

import * as css from './AppContent.css';

export const DirectMessagingApp = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { community } = useCommunityContext();
  const { conversations } = useChatContext();
  const { siteFeatures, directMessagingEnabled } = useSiteFeaturesContext();
  const router = useRouter();

  const isDMsOn = siteFeatures?.directMessaging?.isEnabled && directMessagingEnabled;
  const showSidebar =
    (conversations?.length && isDMsOn) ||
    router.pathname === pathnames.directMessaging.conversation;

  useEffect(() => {
    // TODO: replace with school colors
    setGlobalCSSVariables(community.primaryColor);
  }, [community]);

  return (
    <main className={classNames(css.mainApp, className)}>
      {showSidebar && <Sidebar type={SidebarType.DMS} />}
      <div className={css.content}>{children}</div>
    </main>
  );
};

export default DirectMessagingApp;
